import { support3Color, primaryColor, hexToRgb } from 'assets/jss/material-dashboard-pro-react';

const dashboardNavbarStyle = (theme) => ({
	brand: {
		marginLeft: '16px',
		marginBottom: 0,
		marginTop: '4px',
		'& a': {
			color: primaryColor[0],
		},
	},
	minimizeButton: {
		transition: 'all .1s ease-in-out',
		'& svg': {
			color: primaryColor[0],
			transform: theme.direction === 'rtl' ? 'rotate(180deg)' : 'none',
		},
		'&, &:hover, &:focus': {
			boxShadow: `0 1px 4px 0 rgba(0, 0, 0, 0.14), 0 7px 6px -5px ${support3Color}`,
		},
		'&:hover': {
			backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, 0.2)`,
		},
		'&:active': {
			backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, 0.3)`,
		},
		[theme.breakpoints.up('md')]: {
			'&:hover, &:active': {
				'& svg:first-of-type': {
					display: 'none',
				},
				'& svg:nth-of-type(2)': {
					display: 'block!important',
				},
			},
		},
	},
	miniActive: {
		[theme.breakpoints.up('md')]: {
			'&:hover svg, &:active svg': {
				'&:nth-of-type(2)': {
					display: 'none!important',
				},
				'&:last-of-type': {
					display: 'block!important',
				},
			},
		},
	},
	arrowBack: {
		display: 'none!important',
	},
	arrowForward: {
		display: 'none!important',
	},
});

export default dashboardNavbarStyle;
